import _DashboardService from "../services/dashboard-service";
import { IDashboardService } from "../types/services/dashboard-service";

const DashboardService: IDashboardService = new _DashboardService();

export default DashboardService;
